import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, TabContent, TabPane, NavLink } from "reactstrap";
import classNames from "classnames";

import { setActiveTabIndex } from "@store";

import { TopBanner } from "@pages/GeneralConfig/Design/Content/SalesMethods/Design/TopBanner";

import { Header } from "@pages/GeneralConfig/Design/Content/SalesMethods/Design/Header";
import { SalesMethods } from "@pages/GeneralConfig/Design/Content/SalesMethods/Design/SalesMethods";
import { ActionsButtons } from "@pages/GeneralConfig/Design/Content/SalesMethods/Design/ActionsButtons";

import "@components/Common/Design/index.css";
import "@pages/GeneralConfig/Design/index.css";

export function Design(): JSX.Element {
    const { t } = useTranslation();

    const tabs: TabsType[] = [
        {
            title: t("General"),
            content: <TopBanner />,
            customClassName: "cgt_txt_general",
        },
        {
            title: t("Header"),
            content: <Header />,
            customClassName: "cgt_txt_header",
        },
        {
            title: t("Sales methods"),
            content: <SalesMethods />,
            customClassName: "cgt_txt_optionSaleMethods",
        },
        {
            title: t("Actions Buttons"),
            content: <ActionsButtons />,
            customClassName: "cgt_txt_actionButtons",
        },
    ];

    const [activeTab, setActiveTab] = React.useState<number>(0);

    function toggleNav(tab: number) {
        if (activeTab !== tab) setActiveTab(tab);
    }

    return (
        <div className="design-container-items__clz">
            <div
                style={{
                    width: "85%",
                    height: "98%",
                    backgroundColor: "#EDEDED",
                }}
                className="m-2 border-0 rounded"
            >
                <div className="p-2 mt-1 text-center font-weight-bold cursor__clz">
                    {t("Setup options")}
                </div>
                <Nav tabs className="mt-2">
                    {tabs.map((element, index) => {
                        return (
                            <NavItem key={index} style={{ width: "100%" }}>
                                <NavLink
                                    className={classNames(
                                        "nav-link__clz",
                                        {
                                            "active design-tab-nav-tabs-active-link__clz":
                                                activeTab === index,
                                        },
                                        element.customClassName
                                    )}
                                    onClick={() => {
                                        toggleNav(index);
                                        setActiveTabIndex(index);
                                    }}
                                >
                                    <span className="mx-2">
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        );
                    })}
                </Nav>
            </div>
            <div>
                <TabContent
                    activeTab={activeTab}
                    style={{ width: "100%", height: "95%" }}
                >
                    {tabs.map((element, index) => {
                        return (
                            <TabPane
                                tabId={index}
                                style={{ height: "100%", width: "100%" }}
                                key={index}
                            >
                                {element.content}
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
        </div>
    );
}
